<div>
    <div class="modal-header">
     <div>
      <h4 class="modal-title" id="modal-basic-title">{{'home.recordpickup.recordDelivery'| cxTranslate}}</h4>
      <p>{{nominationData?.nominationNumber}}</p>
      </div>
        <i class="fa fa-times close-icon" aria-hidden="true" (click)="closeModal()"></i>
		
	</div>
  <div id="loader"*ngIf="enableLoader" class="overlay-loader loading-spinner"></div>
	<div class="modal-body">
    <form [formGroup]="form"  *ngIf="!enableLoader">
      <table class="table" >
        <thead class="thead-light">
          <tr>
            <th scope="col">{{'home.recordpickup.deliveryQuantity'| cxTranslate}}</th>
            <th scope="col">{{'home.recordpickup.deliveryDate'| cxTranslate}}</th>
            <th scope="col">{{'home.recordpickup.deliveryMode'| cxTranslate}}</th>
            <th scope="col"></th>  
          </tr>
        </thead>
        <tbody formArrayName="nominationItemRecordPickUpEntryRequest" *ngFor="let deliveryForm of nominationItemRecordPickUpEntryRequest.controls; let i = index">
          <tr [formGroup]="deliveryForm">
              <td scope="row">
              <div class="input-group ">                          
                <input class="form-control" placeholder="" formControlName="quantityCollected" required
                appAllowNegativeDecimalNumber
                [beforeDecimal]="6"
								[afterDecimal]="3">
              </div>
              <div class="text-danger" *ngIf="deliveryForm.controls.quantityCollected.touched && deliveryForm.controls.quantityCollected.errors?.required">{{'home.recordpickup.deliveryQuantityErrmsg'| cxTranslate}}</div>
            </td>
            <td >
              <div class="d-flex date-select">
                <div class="input-group" >
                  <input
                  class="form-control"
                  placeholder="DD/MM/YYYY"
                  name="dp_{{i}}"                              
                  ngbDatepicker
                  #d="ngbDatepicker"
                  formControlName="dateCollected"
                  id="dvl_date_{{i}}" 
                  readonly="true"  
                  required  
                  (click)="d.toggle()"          
                />
                </div>
                <i class="far pickup-calendar " (click)="d.toggle()" ><img src="/images/calendar.svg"   alt="customlogo" width="18px" height="18px" class="" ></i>
              </div>
              <div class="text-danger" *ngIf="deliveryForm.controls.dateCollected.touched && deliveryForm.controls.dateCollected.errors?.required">{{'home.recordpickup.deliveryDateErrmsg'| cxTranslate}}</div>
            </td>
            <td>
              <select class="form-control" required formControlName="portsidePartnerTransportEnum">
                <option  *ngFor="let mode of transportModes" value="{{mode.code}}">{{mode.description}}</option>             
              </select>
              <div class="text-danger" *ngIf="deliveryForm.controls.portsidePartnerTransportEnum.touched && deliveryForm.controls.portsidePartnerTransportEnum.errors?.required">{{'home.recordpickup.ModeErrmsg'| cxTranslate}}</div>
            </td>
            <td>
              <i class="fas fa-minus-circle text-primary remove-icon"  [ngClass]="{ 'text-muted': isInvoiceCreationSuccess, 'text-primary': !isInvoiceCreationSuccess }" (click)="deleteDelivery(i)"></i> 
            </td>
            
          </tr>  

        </tbody>
      </table>   
             <!-- empty row validation -->
      <div class="mt-2 text-center" *ngIf="emptysaveErr">
        <p class="mb-0" style="color: red;">{{'home.recordpickup.emptySaveerr'| cxTranslate}}</p>
      </div>
      <div class="row d-flex align-items-baseline p-2 ml-0">
          <i class="fa-solid fa-plus fa-lg large text-primary pr-2" [ngClass]="{'disabled-del': nominationData.isDeliveryCompleted===true}"(click)="addDelivery('')"></i><span class="text-primary fw-bold"
 (click)="addDelivery('')" [ngClass]="{'disabled-del': nominationData.isDeliveryCompleted===true}">{{'home.recordpickup.addDelivery'| cxTranslate}}</span>
        </div>
        <div class="p-2 d-flex align-items-center total-row" style = "background-color: #CED4DA;border-left: 8px;border-right: 8px;">
        <div class="total-value-wrap">

          <span class="totalValue">{{totalQuantityCollected | number:'1.0-3'}}</span>

        <!-- Show info SVG if not validated, else show warning SVG if validation failed -->
        <!-- Info SVG before validation -->
        <img src="/images/info.svg" *ngIf="(azureStatus | lowercase)=='not_initiated'" [ngbTooltip]="'home.recordpickup.AzureNotValidated' | cxTranslate"  alt="Not yet validated" width="20px" height="20px">
        <!-- Warning SVG only after validation attempt and failure -->
        <img src="/images/warning.svg" *ngIf="(azureStatus | lowercase) === 'failure' " [ngbTooltip]="'home.recordpickup.AzureUnsuccessfulValidation' | cxTranslate" alt="Unsuccessful validation" width="20px" height="20px" >
        <!-- Success SVG only after validation attempt and success -->
        <img src="/images/check_circle.svg" *ngIf="(azureStatus | lowercase) === 'success' " [ngbTooltip]="'home.recordpickup.AzureValidatedSuccessfully' | cxTranslate" alt="Validated successfully" width="20px" height="20px" >
        <img src="/images/partial_success.svg" *ngIf="(azureStatus | lowercase) === 'partial_success' " [ngbTooltip]="'home.recordpickup.AzurePartialSuccess' | cxTranslate" alt="Partial success" width="20px" height="20px" >
        <img src="/images/pending.svg" *ngIf="(azureStatus | lowercase) === 'in_progress' " [ngbTooltip]="'home.recordpickup.AzureValidating' | cxTranslate" alt="Validating..." width="20px" height="20px" >
        
      </div>
       
         <label for="totalQuantity" class="form-label fw-bold mb-0 total-label">{{'home.recordpickup.totalDelivery' | cxTranslate}}</label>
      
      </div>
       
      
    
       <!--Not yet validated-->
      <div *ngIf="(azureStatus | lowercase)=='not_initiated' &&  deliveryCompleted === 'yes'" class="mt-2 pt-3 pb-3 pl-3 validate-msg" role="alert"style = "color: #666666 ; background-color: #84B5D91F;display:flex;justify-content: center">
      {{'home.recordpickup.validationResults' | cxTranslate}}
      </div>
        <!--Not yet validated-->
      <div *ngIf="(azureStatus | lowercase)=='not_initiated'  && deliveryCompleted === 'no'" class="mt-2 pt-3 pb-3 pl-3 validate-msg" role="alert"style = "color: #666666 ; background-color: #84B5D91F;display:flex;justify-content: center">
      {{'home.recordpickup.saveChanges' | cxTranslate}}
      </div>
      <!--In progress-->
      <div *ngIf="(azureStatus | lowercase)=='in_progress'" class="alert alert-info mt-2 pl-2 validate-msg" role="alert" style = "background-color:#E59D0742;color: #5C1715;border-radius: 4px; border: 1px solid #DD5900; display: flex;
      justify-content: flex-start;">
      {{'home.recordpickup.dataSubmitted' | cxTranslate}}
     </div>
      <!-- Validation success message -->
      <div *ngIf="(azureStatus | lowercase) === 'success' " class=" mt-2 pt-3 pb-3 pl-3 validate-msg" style=" border: 1px solid #bdbdbd; background: #84B5D91F;color: #1A1A1A;display: flex;justify-content: center;">
     {{azureValidationRemark}}
      </div>
      <!-- Validation error message -->
      <div  *ngIf="(azureStatus | lowercase) === 'failure' "class="mt-2 p-2 pl-3 validate-msg" style="background: #84B5D91F;border: 1px solid #FF2D41; display: block;color: #5C1715">
        {{azureValidationRemark}}
      </div>
     <div *ngIf="(azureStatus | lowercase) === 'partial_success' " class="mt-2 pt-3 pb-3 pl-4 pl-3" style="border: 1px solid #048A24; background: #12983242;display: block;color: #001B1A">
      {{azureValidationRemark}}
      </div>
     <div class = "mt-4 ml-2" style = "border: 1px solid #fff; background-color: #fff;">
        <label for="remarks" class="form-label fw-bold">{{'home.recordpickup.remarks'| cxTranslate}}</label>
        <textarea class="form-control" id="remarks" rows="3" formControlName="remarks" [readonly]="isInvoiceCreationSuccess"></textarea>
      </div>
    
      <div class="d-flex p-2 justify-content-between">
        <div class="width-70">
          <label for="deliveryCompleted" class="form-label fw-bold">{{'home.recordpickup.deliveryCompleted'| cxTranslate}}</label>
        </div>
       
        <div class="col-sm-4 col-md-2 col-lg-2 p-0 w-50 ">
          <div class="btn-group btn-group-toggle col-md-4 col-sm-4 col-xs-4 p-0" data-toggle="buttons">
            <label id="yes" class="btn m-0 border b-dvl b-height" [ngClass]="uploaddoc==true? 'active_yes':''"
              (click)="recordelivery('yes')">
                <input type="radio" formControlName="deliveryCompleted" name="options" id="{{'optionyes'}}"
                class="h6 btn btn-block btn-light m-0 border1" [disabled]="uploaddoc==true">{{'home.recordpickup.yes'|
              cxTranslate}}</label>
            <label id="no" class="btn m-0 border b-dvl b-height"
              [ngClass]="{'active_no': uploaddoc==false, 'disabled-del unabletoclick': nominationData?.isDeliveryCompleted === true}"
              (click)="recordelivery('no')">
              <input type="radio" [disabled]="uploaddoc==true" formControlName="deliveryCompleted" name="options"
                id="{{'optionno'}}" class="h6 btn btn-block btn-light m-0 border1">{{'home.recordpickup.no'|
              cxTranslate}}</label>
          </div>
                </div>
      </div>
<!-- file upload -->
<div>
  <div class="dropdiv" (dragover)="onDragOver($event)" (drop)="onDropSuccess($event)">
    <div class="d-none d-sm-block d-md-block d-lg-block">
      <div class="d-flex justify-content-between p-2 align-items-center">
        <div class="d-flex justify-content-between">
          <img src=".././images/upload-img.svg" class="p-2">
          <div class="m-2"> 
            <p class="mb-1">{{'home.recordpickup.selectFileLongText'| cxTranslate}}</p>
            <p class="mb-1 text-secondary font-change">{{'home.recordpickup.fileSizeText'| cxTranslate}}</p>
          </div>
        </div>
        <div class="btn-width">
          <label class="custom-file-upload btn btn-secondary btn-lg btn-block">               
              <input accept="application/pdf, image/jpg, image/jpeg, image/png" [disabled]="nominationData.isDeliveryCompleted === true" (onFileSelected)="onChange($event)" type="file"   ng2FileSelect [uploader]="uploader" />
              {{'home.recordpickup.selectFile'| cxTranslate}}
          </label>
        </div>
      </div>
    </div>
    <div class="d-lg-none d-sm-none d-md-none">
     <div>
      <div class="d-flex justify-content-between p-2 align-items-center">
        <div class="d-flex justify-content-between">
          <img src=".././images/upload-img.svg" class="p-2">
          <div class="m-2">
            <p class="mb-1">{{'home.recordpickup.selectFileLongText' | cxTranslate}}</p>
            <p class="mb-1 text-secondary font-change">{{'home.recordpickup.fileSizeText'| cxTranslate}}</p>
          </div>
        </div>
      </div>
      <div class="mobile-view-button">
        <label class="custom-file-upload btn btn-secondary btn-lg">               
            <input accept="application/pdf, image/jpg, image/jpeg, image/png" (onFileSelected)="onChange($event)" type="file"   ng2FileSelect [uploader]="uploader"/>
            {{'home.recordpickup.selectFile'| cxTranslate}}
        </label>
      </div>
     </div>
    </div>
  </div>
<div *ngIf="filesLength || nominationData.attachments">
 <div class="d-none d-lg-block d-sm-block d-md-block">
  <div class="filesection mt-2"  *ngFor="let file of fileArray;let i=index;">
    <div class="d-flex" >
      <div class="d-flex align-items-center w-100 m-2">
        <img src=".././images/file-alt.svg" class="p-2">
        <div class="w-100">
          <p class="file_name">{{file.name || file.documentName}}<a *ngIf="file.downloadURL!=undefined" class="pt-2 btn btn-sm text-primary shadow-none small" href="{{file.downloadURL}}">{{'home.recordpickup.preview' | cxTranslate}}</a></p>
          <p class="file_size text-secondary">{{file.size / 1024 / 1024 | number: '.3'}}MB / {{file.size / 1024 / 1024 | number: '.3'}}MB</p> 
          
            <div class="progress border border-secondary">
              <div class="progress-bar w-100 rounded-border" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
              
            </div>
        </div>
      </div>
      <div >
        <i class="fa fa-times close-icon p-2" aria-hidden="true" (click)="removeFile(i)"  [ngClass]="{'disabled-del': nominationData.isDeliveryCompleted===true}" ></i>
        <p class="text-secondary position-relative small mb-0 mt-3 pt-2">100%</p>
      </div>
    </div>
  </div>
 </div>
 <div class="d-lg-none d-sm-none d-md-none">
  <div class="filesection-mobile mt-2"  *ngFor="let file of fileArray;let i=index;">
    <div class="d-flex" >
      <div class="d-flex align-items-center w-100 m-2">
        <img src=".././images/file-alt.svg" class="p-2">
        <div class="p-2 w-100">
          <p class="file_name">{{file.name || file.documentName}}<a *ngIf="file.downloadURL!=undefined" class="pt-2 btn btn-sm text-primary shadow-none small" href="{{file.downloadURL}}">{{'home.recordpickup.preview' | cxTranslate}}</a></p>
          <p class="file_size text-secondary">{{file.size / 1024 / 1024 | number: '.3'}}MB / {{file.size / 1024 / 1024 | number: '.3'}}MB</p> 
        </div>
      </div>
      <div >
        <i class="fa fa-times close-icon p-2" aria-hidden="true" (click)="removeFile(i)"></i>
        
      </div>
    </div>
  </div>
 </div>
</div>
  
</div>
<!-- attchment validation -->
<div *ngIf="uploadErr == true">
  <div class="" >
    <div class="filesection_warning mt-2 mb-2" >
      <div class="d-flex">
        <div class="d-flex align-items-center w-100 m-2">
          <img src="/icons/Vector.svg" class="p-2">
          <div class="p-2 w-100">
            <p class="upload_file_name">{{'home.recordpickup.uploadFileText'| cxTranslate}}</p>
            <p class="upload_file_secondary_text">{{'home.recordpickup.uploadFileBelowText'| cxTranslate}}</p> 
          </div>
        </div>
        <div >
          <i class="fa fa-times close-icon p-2" aria-hidden="true" (click)="removeWarning()"></i>
        </div>
      </div>
    </div>
  </div>
 </div>
    </form>   
    </div>
   <div class="d-lg-none" *ngIf = "!enableLoader">
    <div class="p-3">
      <button
        *ngIf="((azureStatus | lowercase)=='not_initiated' || (azureStatus | lowercase)=='in_progress' && azureValidationRemark=='') && form.get('deliveryCompleted')?.value === 'yes' && isInvoiceCreationSuccess === false"
        type="button" class="btn btn-primary-record bg-transparent btn-block mb-3" [disabled]="(azureStatus | lowercase)=='in_progress'" (click)="onValidateClick()">
        <span *ngIf="(azureStatus | lowercase)=='in_progress'" class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
        <img *ngIf="(azureStatus | lowercase)=='not_initiated'" src="/images/validate.svg" alt="customlogo" width="20px" height="20px"> {{'home.recordpickup.validate' | cxTranslate}}
      </button>
      <button
        *ngIf="((azureStatus | lowercase)=='failure' || (azureStatus | lowercase)=='partial_success' || (azureStatus | lowercase)=='in_progress' && azureValidationRemark!='') && form.get('deliveryCompleted')?.value === 'yes' && isInvoiceCreationSuccess === false"
        type="button" class="btn btn-primary-record bg-transparent btn-block mb-3" (click)="onRevalidateClick()" [disabled]="(azureStatus | lowercase)=='in_progress' && !showRevalidate">
        <span *ngIf="(azureStatus | lowercase)=='in_progress' && !showRevalidate" class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
        <img *ngIf="(azureStatus | lowercase)=='failure' || (azureStatus | lowercase)=='partial_success' || showRevalidate" src="/images/restart_alt.svg" alt="customlogo" width="20px" height="20px"> {{'home.recordpickup.reValidate' | cxTranslate}}
      </button>
      
      <button *ngIf="!isInvoiceCreationSuccess && showNextButton== false && deliveryCompleted === 'no'" type="button" [disabled]="(form.invalid) || (emptysaveErr)"  class="btn btn-primary btn-block" (click)="SaveRecord(form)">{{'home.recordpickup.save'| cxTranslate}}</button>
      <button *ngIf="(deliveryCompleted === 'yes' && !isInvoiceCreationSuccess && (azureStatus | lowercase)!=='not_initiated') ||(showNextButton === true)"  type="button" [disabled]="(form.invalid) || (emptysaveErr)" class="btn btn-primary btn-block" (click)="SaveRecord(form, true)">{{'shipment.next' | cxTranslate}}</button>
      <button type="button" class="btn btn-outline-secondary btn-block" (click)="closeModal()">{{'home.recordpickup.cancel'| cxTranslate}}</button>
    </div>
   </div>
   <div class="d-none d-lg-block">
    <div class="modal-footer  " *ngIf = "!enableLoader">
      <div class="d-flex align-items-center mr-auto">
               <div class="mb-3 d-flex align-items-center justify-content-between position-relative">   
            
                 <button
                    *ngIf="((azureStatus | lowercase)=='not_initiated' || (azureStatus | lowercase)=='in_progress' && azureValidationRemark=='') && form.get('deliveryCompleted')?.value === 'yes' && isInvoiceCreationSuccess === false"
                    type="button" class="btn btn-primary-record bg-transparent mr-2" [disabled]="(azureStatus | lowercase)=='in_progress'" (click)="onValidateClick()">
                    <span *ngIf="(azureStatus | lowercase)=='in_progress'" class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                    <img *ngIf="(azureStatus | lowercase)=='not_initiated'" src="/images/validate.svg" alt="customlogo" width="20px" height="20px"> {{'home.recordpickup.validate' | cxTranslate}}
                  </button>
                <button
                    *ngIf="((azureStatus | lowercase)=='failure' || (azureStatus | lowercase)=='partial_success' || (azureStatus | lowercase)=='in_progress' && azureValidationRemark!='') && form.get('deliveryCompleted')?.value === 'yes' && isInvoiceCreationSuccess === false"
                    type="button" class="btn btn-primary-record bg-transparent" (click)="onRevalidateClick()" [disabled]="(azureStatus | lowercase)=='in_progress' && !showRevalidate"
                    style="display: flex; align-items: center; gap: 10px">`
                    <span *ngIf="(azureStatus | lowercase)=='in_progress' && !showRevalidate" class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                    <img *ngIf="(azureStatus | lowercase)=='failure' || (azureStatus | lowercase)=='partial_success' || showRevalidate" src="/images/restart_alt.svg" alt="customlogo" width="20px" height="20px"> {{'home.recordpickup.reValidate' | cxTranslate}}</button>
                    <button *ngIf="showReload && deliveryCompleted === 'yes'" type="button" class="btn btn-primary-record bg-transparent ml-2" (click)="getDvlDetails()"> {{'home.recordpickup.Reload' | cxTranslate}} </button>
                </div>
            </div>
      <div class="d-flex align-items-center mr-3">
          <button  *ngIf="!isInvoiceCreationSuccess && showNextButton==false && deliveryCompleted === 'no'"  type="button" [disabled]="(form.invalid) || (emptysaveErr)"  class="btn btn-primary mr-3" (click)="SaveRecord(form)">{{'home.recordpickup.save'| cxTranslate}}</button>
            <button *ngIf="(deliveryCompleted === 'yes' && !isInvoiceCreationSuccess && (azureStatus | lowercase)!=='not_initiated') ||(showNextButton === true)"  type="button" [disabled]= "(form.invalid) || (emptysaveErr)" class="btn btn-primary mr-3" (click)="SaveRecord(form, true)">{{'shipment.next' | cxTranslate}}</button>
            <button type="button" class="btn btn-outline-secondary" (click)="cancel()">{{'home.recordpickup.cancel'| cxTranslate}}</button>
          </div>
    </div>
   </div>
  </div>